/**
 * The part of the code editors everything else may touch without dragging Monaco along —
 * tests and the shell import from here; only the editor component itself loads the real thing.
 */

export interface CodeProblem {
  readonly line: number
  readonly column: number
  readonly message: string
}

/** The names the code editor's completion list offers inside `exercise "…"`. */
export const exerciseNames: { current: string[] } = { current: [] }

export function setExerciseNames(names: string[]): void {
  exerciseNames.current = names
}
